<template>
  <div>
    <div class="title-dialog">
      <span>{{ language.user_change_password }}</span>
    </div>
    <div class="item-line">
      <span>{{ language.user_password_old }} <span class="cl-red">*</span></span>
      <el-input
        v-model="modelData.old_password"
        size="medium"
        show-password
      ></el-input>
    </div>
    <div class="item-line">
      <span>{{ language.user_password_new }} <span class="cl-red">*</span></span>
      <el-input
        v-model="modelData.password"
        size="medium"
        show-password
      ></el-input>
    </div>
    <div class="item-line">
      <span>{{ language.user_enter_password_new }} <span class="cl-red">*</span></span>
      <el-input
        v-model="modelData.password_confirmation"
        size="medium"
        show-password
      ></el-input>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <el-button type="primary" plain @click="cancel()">{{ language.common_cancel }}</el-button>
      <el-button
        type="primary"
        @click="submitChange()"
        :disable="!canSubmit"
        :loading="!canSubmit"
      >{{ language.common_save }}</el-button>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import ls from "local-storage";
  import { mapGetters } from "vuex";

  export default {
    name: "ChangePassword",
    metaInfo() {
      return {
        title: "",
      };
    },
    components: {},
    data() {
      return {
        canSubmit: true,
        modelData: {
          old_password: "",
          password: "",
          password_confirmation: "",
        },

      };
    },
    computed: {
      ...mapGetters("account", ["accountInfo", "language"]),
    },
    mounted() {},
    methods: {
      cancel (){
        this.modelData = {
          password: "",
          old_password: "",
          password_confirmation: "",
        };
        this.$emit("cancelChange", true);
      },
      async submitChange () {
        let  data = this.modelData
        this.canSubmit = false;
        await axios.post("account/change-password", data).then((response) => {
          this.canSubmit = true;
          switch (response.code) {
            case 200:
              this.$notify({
                message: response.message,
                type: "success",
              });
              this.modelData = {
                password: "",
                old_password: "",
                password_confirmation: "",
              };
              this.$emit("cancelChange", true);
              var token = ls.get("authen", "");
              if (token) {
                ls.remove("authen");
              }
              location.reload();
              this.$router.push({ name: "account-login" });
              break;
            case 422:
              this.$notify({
                title: response.message,
                message: Object.values(response.data)[0],
                type: "warning",
              });
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });

      }
    },
    watch: {},
  };
</script>

<style lang="css" scoped>
  .cl-red {
    color: red;
  }
</style>
